// Pure rate-simulator math (Section 4C, spec p.25).
// rows: [{ gti, nights, guest_name, drive_distance_miles, trip_cost_ratio }]
// ratePerNight: number (dollars)
// Accepts `nights` or `num_nights` so it works directly against API rows.
// Returns aggregate totals AND per-guest rows for the impact table.
export function simulateRateImpact(rows, ratePerNight) {
  const arr = (rows || []).filter((r) => {
    const n = r?.nights ?? r?.num_nights;
    return r && r.gti != null && n != null;
  });
  const perGuest = arr.map((r) => {
    const nights = Number(r.nights ?? r.num_nights);
    const current = Number(r.gti);
    const change = nights * Number(ratePerNight || 0);
    const next = current + change;
    const pct = current > 0 ? (change / current) * 100 : 0;
    return {
      guest_name: r.guest_name || 'Anonymous',
      drive_distance_miles: r.drive_distance_miles ?? null,
      nights,
      currentGti: Math.round(current),
      newGti: Math.round(next),
      change: Math.round(change),
      pct: Math.round(pct * 10) / 10,
      trip_cost_ratio: r.trip_cost_ratio ?? null,
    };
  });
  const oldGti = arr.reduce((s, r) => s + Number(r.gti), 0);
  const change = arr.reduce((s, r) => s + Number(r.nights ?? r.num_nights) * Number(ratePerNight || 0), 0);
  const newGti = oldGti + change;
  const pct = oldGti > 0 ? (change / oldGti) * 100 : 0;
  return {
    oldGti: Math.round(oldGti),
    newGti: Math.round(newGti),
    change: Math.round(change),
    pct: Math.round(pct * 10) / 10,
    guests: arr.length,
    rows: perGuest,
  };
}
